import React, { createContext, useContext } from 'react';
import { TargetLayer } from 'rwl-shared/dist/models/analytics';

interface AnalyticsTargetLayerProviderProps {
    targetLayer?: TargetLayer;
    targetLayerId?: string;
}

interface AnalyticsTargetLayerContextType {
    targetLayer?: TargetLayer;
    targetLayerId?: string;
}

const AnalyticsTargetLayerContext = createContext<
    AnalyticsTargetLayerContextType | undefined
>(undefined);

export const AnalyticsTargetLayerProvider: React.FC<
    AnalyticsTargetLayerProviderProps
> = ({ targetLayer: layer, targetLayerId: layerId, children }) => {
    return (
        <AnalyticsTargetLayerContext.Provider
            value={{ targetLayer: layer, targetLayerId: layerId }}
        >
            {children}
        </AnalyticsTargetLayerContext.Provider>
    );
};

export const useAnalyticsTargetLayer = (): AnalyticsTargetLayerContextType => {
    const context = useContext(AnalyticsTargetLayerContext);
    if (!context) {
        throw new Error(
            'useAnalyticsTargetLayer must be used within an AnalyticsTargetLayerProvider'
        );
    }
    return context;
};
